<!-- eslint-disable vue/no-v-html -->
<template>
	<v-container class="container mx-auto px-4 mt-10">
		<v-row>
			<v-col class="font-weight-bold">
				Nueva entrada de blog
				<v-btn color="primary" text small class="ml-4" @click="preview = true">
					Vista previa
				</v-btn>
			</v-col>
			<v-col cols="12">
				<v-text-field
					v-model="form.title"
					dense
					filled
					full-width
					hint="Titulo"
					persistent-hint
					type="text"
				>
				</v-text-field>
			</v-col>
			<v-col cols="12">
				<v-text-field
					v-model="form.subtitle"
					dense
					filled
					full-width
					hint="Subtitulo"
					persistent-hint
					type="text"
				>
				</v-text-field>
			</v-col>
			<v-dialog v-model="preview" fullscreen>
				<v-card>
					<v-toolbar color="primary" class="white--text">
						Vista previa
						<v-spacer></v-spacer>
						<v-btn color="white" text @click="preview = false">Cerrar</v-btn>
					</v-toolbar>
					<v-row justify="center" class="mt-4">
						<v-col cols="12" sm="4">
							<v-img :src="thumbnailUrl" class="rounded-xl"></v-img>
						</v-col>
						<v-col cols="16" sm="6">
							<h1>{{ form.title ? form.title : 'Titulo' }}</h1>
							<h2>{{ form.subtitle ? form.subtitle : 'Subtitulo' }}</h2>
							<div
								class="font-weight-light"
								v-html="
									form.HTMLbody
										? form.HTMLbody
										: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Fugit eos, expedita quas soluta repudiandae distinctio sed sequi provident quae ea numquam beatae eligendi. Dolorum amet omnis nulla adipisci sed laboriosam.'
								"
							></div>
						</v-col>
					</v-row>
				</v-card>
			</v-dialog>
			<v-col cols="12">
				<vue-editor v-model="form.HTMLbody"></vue-editor>
			</v-col>
			<v-col cols="12"> Foto de portada </v-col>
			<v-col cols="12">
				<input
					id="formFile"
					class="form-control block w-full py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
					type="file"
					@change="setThumbnail"
				/>
			</v-col>
			<v-col cols="12">
				<v-btn
					:disabled="!form.thumbnail || !form.title || !form.subtitle || !form.HTMLbody"
					tile
					depressed
					color="primary"
					:loading="loading"
					@click="submitForm"
				>
					Agregar entrada
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { VueEditor } from 'vue2-editor/dist/vue2-editor.core.js';
import axios from '@/plugins/axios';
import compress from '@/mixins/compress.js';

export default {
	components: { VueEditor },
	data() {
		return {
			preview: false,
			loading: false,
			form: null,
			thumbnailUrl: '',
		};
	},
	mixins: [compress],
	created() {
		this.defaultForm();
	},
	methods: {
		defaultForm() {
			this.form = {
				HTMLbody: '',
				title: '',
				subtitle: '',
				thumbnail: '',
				categories: '',
				user: '',
				company: '',
				codigoBlog: 'lusazu123',
			};
		},
		setFormData() {
			const formData = new FormData();
			formData.append('codigoBlog', this.form.codigoBlog);
			formData.append('HTMLbody', this.form.HTMLbody);
			formData.append('title', this.form.title);
			formData.append('subtitle', this.form.subtitle);
			formData.append('thumbnail', this.form.thumbnail);
			formData.append('categories', this.form.categories);
			formData.append('user', this.userProfile._id);
			formData.append('company', this.userProfile.company);
			return formData;
		},
		async submitForm() {
			this.loading = true;
			const payload = this.setFormData();
			await axios('/blog/new-article', {
				method: 'POST',
				data: payload,
			});
			this.defaultForm();
			document.getElementById('formFile').value = '';
			this.loading = false;
			alert('Articulo creado!');
		},
		async setThumbnail(e) {
			const file = await this.compressImage(e.target.files[0]);
			this.thumbnailUrl = URL.createObjectURL(file);
			this.form.thumbnail = file;
		},
	},
};
</script>

<style lang="css">
@import '~vue2-editor/dist/vue2-editor.css';
/* Import the Quill styles you want */
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css';
</style>
